import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import graph from './modules/graph'
import tree from './modules/tree'
import myMapTable from './modules/myMapTable'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    graph,
    tree,
    myMapTable
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js